var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuote2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "47px",
    viewBox: "0 0 52 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Project-Editor-4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6363636,10.6818182 L25.6363636,17.1507273 C25.6363636,22.1434091 22.3698636,25.5039091 17.766,26.4118636 L16.8986364,24.5532273 C19.0264545,23.7520909 20.3958636,21.1628182 20.3958636,19.2272727 L17.0909091,19.2272727 L17.0909091,10.6818182 L25.6363636,10.6818182 Z M36.3181818,10.6818182 L36.3181818,17.1507273 C36.3181818,22.1434091 33.0516818,25.5039091 28.4478182,26.4118636 L27.5804545,24.5532273 C29.7082727,23.7520909 31.0776818,21.1628182 31.0776818,19.2272727 L27.7727273,19.2272727 L27.7727273,10.6818182 L36.3181818,10.6818182 Z M47,4.27272727 L47,32.0454545 L22.1263182,32.0454545 L12.8181818,38.6788636 L12.8181818,32.0454545 L4.27272727,32.0454545 L4.27272727,4.27272727 L47,4.27272727 Z M51.2727273,0 L0,0 L0,36.2775909 L8.54545455,36.2775909 L8.54545455,47 L23.5,36.2775909 L51.2727273,36.2775909 L51.2727273,0 Z",
    id: "Shape",
    fill: "#4A4A4A",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote2);
export default __webpack_public_path__ + "static/media/Quote 2.d60a6b15.svg";
export { ForwardRef as ReactComponent };